export enum AlertActionType {
  SHOW_ALERT,
  HIDE_ALERT,
}

export enum AlertSeverity {
  info = "info",
  success = "success",
  warning = "warning",
  error = "error",
}

export type AlertState = {
  show: boolean;
  title: string;
  severity: AlertSeverity;
};

export const hideAlert = (): IAlertAction<any> => {
  return {
    type: "HIDE_ALERT",
  };
};

export const showAlert = (
  title: string,
  severity: AlertSeverity
): IAlertAction<any> => {
  return {
    type: "SHOW_ALERT",
    payload: {
      title,
      severity,
    },
  };
};

export interface IAlertAction<T> {
  type: keyof typeof AlertActionType;
  payload?: T;
}
